export const Marketing = () => (
  <svg
    width="84"
    height="109"
    viewBox="0 0 84 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.5 34.5V16C55.5 7.7157 48.784 1 40.5 1C32.216 1 25.5 7.7157 25.5 16V34.5"
      stroke="#E5CCEE"
      stroke-width="2"
    />
    <path
      d="M25.5 38.5C26.6046 38.5 27.5 37.6046 27.5 36.5C27.5 35.3954 26.6046 34.5 25.5 34.5C24.3954 34.5 23.5 35.3954 23.5 36.5C23.5 37.6046 24.3954 38.5 25.5 38.5Z"
      stroke="#E5CCEE"
      stroke-width="2"
    />
    <path
      d="M55.5 38.5C56.6046 38.5 57.5 37.6046 57.5 36.5C57.5 35.3954 56.6046 34.5 55.5 34.5C54.3954 34.5 53.5 35.3954 53.5 36.5C53.5 37.6046 54.3954 38.5 55.5 38.5Z"
      stroke="#E5CCEE"
      stroke-width="2"
    />
    <path d="M1 26V108H83V26H1Z" stroke="#E5CCEE" stroke-width="2" />
    <path
      d="M25.5 50.5V53.5C25.5 55.709 27.291 57.5 29.5 57.5H51.5C53.709 57.5 55.5 55.709 55.5 53.5V50.5C55.5 48.291 53.709 46.5 51.5 46.5H29.5C27.291 46.5 25.5 48.291 25.5 50.5Z"
      stroke="#E5CCEE"
      stroke-width="2"
    />
    <path d="M1 94H83" stroke="#E5CCEE" stroke-width="2" />
  </svg>
);
